// Pre-order checkbox gate. Blocks add-to-cart until the box is ticked.
// product.preorder (text) is the default; variant.preorder overrides per variant.
// Only rendered when the product has the preorder tag.
(() => {
  if (window.__preorderAck) return;
  window.__preorderAck = true;

  const normalizeVariantId = (raw) => {
    const value = String(raw && typeof raw === 'object' ? raw.id : raw);
    if (!value || value === 'undefined' || value === 'null') return null;
    const id = value.includes('/') ? value.split('/').pop() : value;
    return id || null;
  };

  const parseConfig = (el) => {
    try {
      return JSON.parse(el.textContent.trim());
    } catch {
      return null;
    }
  };

  const formatAck = (template, timeframe) => {
    const bold = `<strong>${timeframe}</strong>`;
    return String(template || '').replace(/\*timeframe\*/g, bold);
  };

  const initAck = (ack) => {
    const form = ack.form;
    if (!form) return;

    const btn = form.querySelector('[name="add"]');
    const label = ack.closest('.preorder-ack');
    const textEl = label && label.querySelector('.preorder-ack__text');
    if (!btn || !label) return;

    const productRoot = form.closest('.js-product') || form;
    const configEl = productRoot.querySelector('#preorder-config');
    const config = configEl ? parseConfig(configEl) : null;

    const defaultTimeframe =
      (config && config.defaultTimeframe) ||
      ack.value.replace(/^Ships in\s+/i, '') ||
      '6 weeks';
    const ackTemplate =
      (config && config.acknowledgement) ||
      ack.dataset.ackTemplate ||
      'I acknowledge this is a preorder item that will ship in *timeframe*';
    const variantMap = (config && config.variants) || {};

    const preorderBtnText = btn.dataset.addToCartText || btn.textContent.trim();
    const defaultBtnText =
      (window.theme && theme.strings && theme.strings.addToCart) || 'Add to cart';
    const propertyName = 'properties[Preorder]';

    let active = true;

    const timeframeFor = (id) => {
      if (!id) return defaultTimeframe;
      const override = variantMap[id];
      return override != null && override !== '' ? override : defaultTimeframe;
    };

    const applyTimeframe = (timeframe) => {
      const tf = timeframe || defaultTimeframe;
      ack.value = `Ships in ${tf}`;
      if (textEl) textEl.innerHTML = `${formatAck(ackTemplate, tf)} `;
    };

    const sync = () => {
      if (!active) return;
      btn.toggleAttribute('aria-disabled', !ack.checked);
      form.classList.toggle('preorder-ack-pending', !ack.checked);
      if (ack.checked) label.classList.remove('preorder-ack--error');
    };

    const setActive = (next, timeframe) => {
      active = next;
      label.hidden = !active;

      if (active) {
        ack.disabled = false;
        ack.required = true;
        ack.name = propertyName;
        applyTimeframe(timeframe);
        btn.dataset.addToCartText = preorderBtnText;
        if (!btn.disabled) btn.textContent = preorderBtnText;
        sync();
        return;
      }

      ack.checked = false;
      ack.required = false;
      ack.disabled = true;
      ack.removeAttribute('name');
      label.classList.remove('preorder-ack--error');
      btn.removeAttribute('aria-disabled');
      form.classList.remove('preorder-ack-pending');
      btn.dataset.addToCartText = defaultBtnText;
      if (!btn.disabled) btn.textContent = defaultBtnText;
    };

    const block = (e) => {
      if (!active || ack.checked) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      label.classList.add('preorder-ack--error');
      ack.focus();
    };

    ack.addEventListener('change', sync);
    form.addEventListener('submit', block, true);
    btn.addEventListener('click', block, true);

    // Product is tagged preorder: always on. Variant metafield only overrides copy.
    const applyVariant = (variant) => {
      const id = variant && variant.id != null ? normalizeVariantId(variant.id) : null;
      setActive(true, timeframeFor(id));
    };

    const idInput = form.querySelector('[name="id"]');
    applyVariant(idInput?.value ? { id: idInput.value } : null);

    productRoot.addEventListener('on:variant:change', (e) => {
      if (e.detail?.form && e.detail.form !== form) return;
      applyVariant(e.detail?.variant);
    });
  };

  const init = () => document.querySelectorAll('.preorder-ack__box').forEach(initAck);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
